/* eslint-disable no-console */
export const error = (err, message) => console.error(err, message);

export const warning = (message) => console.warn(message);

export const tag = (tagName, value) => console.debug('TAG: ', tagName, value);
